import BigPicture from 'bigpicture';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const { $ } = window;
// const $body = $('body');

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    handleVideoClick();
    animateHero();
    animateContentVideo();
    animateSpeakers();
    animateVideos();
    console.log('postSliderSS')
    postSliderSS();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

function matchVimeoUrl(url) {
  var p =
    /^(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)$/;
  return url.match(p) ? RegExp.$1 : false;
}

function handleVideoClick() {
  let videos = document.querySelectorAll('.ss-content-video-video');
  videos.forEach((video) => {
    video.addEventListener('click', function (e) {
      let vimUrl = video.dataset.url
      if (!vimUrl) {
        return;
      }
      e.preventDefault();

      // inject into inline video container
      //document.getElementById('inline_video').innerHTML = 'myiframe<iframe width="100%" src="' + vimurl + '"></iframe>';
      //<iframe width="100%" src="' + vimurl + '"></iframe>';
      //BigPicture({
      //  el: video,
      //  vimeoSrc: vimUrl,
      // });
    });
  });
}

function animateContentVideo() {
  const sections = gsap.utils.toArray('.ss-content-video-section');
  if (!sections.length) {
    return;
  }
  sections.forEach((section) => {
    let header = section.querySelector('h2');
    let subHeader = section.querySelector('h3');
    let content = section.querySelectorAll('p');
    let video = section.querySelector('.ss-content-video-video');

    gsap.set(header, { opacity: 0, y: 16 });
    gsap.set(content, { opacity: 0 });
    gsap.set(video, { opacity: 0 });
    if (subHeader) {
      gsap.set(subHeader, { opacity: 0, y: 32 });
      gsap
        .timeline({
          scrollTrigger: { trigger: section, start: 'top 90%' },
          defaults: { opacity: 1, duration: 0.3, y: 0, x: 0, stagger: 0.15 },
        })
        .to(header, {})
        .to(subHeader, {})
        .to(content, {})
        .to(video, {}, '-=.5');
    } else {
      gsap
        .timeline({
          scrollTrigger: { trigger: section, start: 'top 90%' },
          defaults: { opacity: 1, duration: 0.3, y: 0, x: 0, stagger: 0.15 },
        })
        .to(header, {})
        .to(content, {})
        .to(video, {}, '-=.5');
    }
  });
}

function animateHero() {
  const hero = document.querySelector('.ss-hero');
  if (!hero) {
    return;
  }
  const header = hero.querySelector('h1');
  const content = hero.querySelectorAll('p');
  const video = hero.querySelector('.ss-content-video-video');

  if (video) {
    gsap.set([header, content, video], { opacity: 0 });
    gsap
      .timeline({ defaults: { opacity: 1 } })
      .to(header, {})
      .to(content, {})
      .to(video, {}, '-=.5');
  } else {
    gsap.set([header, content], { opacity: 0 });
    gsap
      .timeline({ defaults: { opacity: 1 } })
      .to(header, {})
      .to(content, {});
  }
}

function animateSpeakers() {
  const speakers = gsap.utils.toArray('.ss-speaker-card');
  if (!speakers) {
    return;
  }
  speakers.forEach((speaker, index) => {
    let delay = index * 0.3;
    const img = speaker.querySelector('.ss-speaker-img');
    const info = speaker.querySelectorAll('.ss-speaker-detail');
    gsap.set([img, info], { opacity: 0, y: 16 });
    gsap.set(speaker, { scaleX: 0 });

    gsap
      .timeline({
        scrollTrigger: { trigger: speaker, start: 'top 90%' },
        defaults: { opacity: 1, y: 1, scaleX: 1, duration: 0.3, stagger: 0.15 },
      })
      .to(speaker, { delay: delay })
      .to(img, {})
      .to(info, {});
  });
}

function animateVideos() {
  const videos = gsap.utils.toArray('.video-card');
  if (!videos.length) {
    return;
  }

  gsap.set(videos, { opacity: 0 });
  gsap.to(videos, {
    scrollTrigger: { trigger: videos, start: 'top 90%' },
    opacity: 1,
    stagger: 0.15,
    duration: 0.3,
  });
}

function postSliderSS() {
  let sections = document.querySelectorAll('.ss-posts-section');
  sections.forEach((section, index) => {
    let prev = section.querySelector('.slide-m-prev');
    let next = section.querySelector('.slide-m-next');
    let dots = section.querySelector('.slide-m-dots');
    let slider = section.querySelector('.ss-posts-wrap');

    prev.classList.add(`prev-${index}`);
    next.classList.add(`next-${index}`);
    dots.classList.add(`dots-${index}`);

    let numSlides = 3
    let responsiveConfig = [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false,
        },
      },
    ];
    if($('body').hasClass('single-theme_pages')){
      numSlides = 4;
      responsiveConfig = [
        // {
        //   breakpoint: 390,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     centerMode: false,
        //   },
        // },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
          },
        },
      ];
    }
      

    $(slider).slick({
      dots: true,
      slidesToShow: numSlides,
      slidesToScroll: numSlides,
      infinite: true,
      center: true,
      appendDots: $(dots),
      prevArrow: $(prev),
      nextArrow: $(next),
      responsive: responsiveConfig,
    });
  });
}
